export default "__VITE_ASSET__ad8b3ed9__"